// @ts-nocheck
import * as Types from '@src/types/graphql-types';

import gql from 'graphql-tag';
import * as React from 'react';
import * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactComponents from '@apollo/react-components';
import * as ApolloReactHooks from '@apollo/react-hooks';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
export type SearchTermQueryVariables = Types.Exact<{
  input?: Types.InputMaybe<Types.ProductSearchTermInput>;
}>;


export type SearchTermQuery = { __typename?: 'Query', getSearchTerm: { __typename?: 'SemiConfigurations', requestDate?: string | null, responseDate?: string | null, count?: number | null, version?: string | null, term?: Array<string | null> | null, reagents?: Array<{ __typename?: 'Reagents', grnaId?: string | null, geneId?: string | null, geneSymbol?: string | null, specificityScore?: string | null, efficiencyScore?: string | null, species?: string | null, moreInformation?: string | null, recommendedStatus?: string | null, price?: string | null, currency?: string | null } | null> | null, controls?: Array<{ __typename?: 'Controls', grnaId?: string | null, geneId?: string | null, geneSymbol?: string | null, specificityScore?: string | null, efficiencyScore?: string | null, species?: string | null, moreInformation?: string | null, recommendedStatus?: string | null, price?: string | null, currency?: string | null } | null> | null, serverError?: { __typename?: 'ServerError', key?: string | null, value?: string | null } | null } };


export const SearchTermDocument = gql`
    query searchTerm($input: ProductSearchTermInput) {
  getSearchTerm(input: $input) {
    requestDate
    responseDate
    count
    version
    term
    reagents {
      grnaId
      geneId
      geneSymbol
      specificityScore
      efficiencyScore
      species
      moreInformation
      recommendedStatus
      price
      currency
    }
    controls {
      grnaId
      geneId
      geneSymbol
      specificityScore
      efficiencyScore
      species
      moreInformation
      recommendedStatus
      price
      currency
    }
    serverError {
      key
      value
    }
  }
}
    `;
export type SearchTermComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SearchTermQuery, SearchTermQueryVariables>, 'query'>;

    export const SearchTermComponent = (props: SearchTermComponentProps) => (
      <ApolloReactComponents.Query<SearchTermQuery, SearchTermQueryVariables> query={SearchTermDocument} {...props} />
    );
    

/**
 * __useSearchTermQuery__
 *
 * To run a query within a React component, call `useSearchTermQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchTermQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchTermQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchTermQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<SearchTermQuery, SearchTermQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SearchTermQuery, SearchTermQueryVariables>(SearchTermDocument, options);
      }
export function useSearchTermLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SearchTermQuery, SearchTermQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SearchTermQuery, SearchTermQueryVariables>(SearchTermDocument, options);
        }
export type SearchTermQueryHookResult = ReturnType<typeof useSearchTermQuery>;
export type SearchTermLazyQueryHookResult = ReturnType<typeof useSearchTermLazyQuery>;
export type SearchTermQueryResult = ApolloReactCommon.QueryResult<SearchTermQuery, SearchTermQueryVariables>;